function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5234 1.52734C11.9375 0.1875 9.50391 0.378906 8 1.9375C6.46875 0.378906 4.03516 0.1875 2.44922 1.52734C0.398438 3.25 0.699219 6.06641 2.17578 7.57031L6.96094 12.4648C7.23438 12.7383 7.58984 12.9023 8 12.9023C8.38281 12.9023 8.73828 12.7383 9.01172 12.4648L13.8242 7.57031C15.2734 6.06641 15.5742 3.25 13.5234 1.52734ZM12.8672 6.64062L8.08203 11.5352C8.02734 11.5898 7.97266 11.5898 7.89062 11.5352L3.10547 6.64062C2.09375 5.62891 1.90234 3.71484 3.29688 2.53906C4.36328 1.63672 6.00391 1.77344 7.04297 2.8125L8 3.79688L8.95703 2.8125C9.96875 1.77344 11.6094 1.63672 12.6758 2.51172C14.0703 3.71484 13.8789 5.62891 12.8672 6.64062Z",
  fill: "white"
});

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.de50304f.svg";
export { ForwardRef as ReactComponent };